import React from 'react';
import FormBuilder from '../components/FormBuilder';

function CreateFormPage() {
  return (
    <div>
      <FormBuilder />
    </div>
  );
}

export default CreateFormPage;
